export default __webpack_public_path__ + "images/EAF.27b6cba.png";